var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import cadService from "@/core/services/cadService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Status_MaterialActions } from "@/store/enums/CadEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Status_MaterialModule = class Status_MaterialModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Status_MaterialActions.POST_STATUS_MATERIAL](data) {
        return new Promise(resolve => {
            cadService.post("Status_Material/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Status_MaterialActions.PUT_STATUS_MATERIAL](data) {
        return new Promise(resolve => {
            cadService.put("Status_Material/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Status_MaterialActions.DELETE_STATUS_MATERIAL](data) {
        return new Promise(resolve => {
            cadService.delete("Status_Material/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Status_MaterialActions.DELETE_RANGE_STATUS_MATERIAL](data) {
        return new Promise(resolve => {
            cadService.delete("Status_Material/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Status_MaterialActions.FILTER_STATUS_MATERIAL](data) {
        return new Promise(resolve => {
            cadService.post("Status_Material/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Status_MaterialActions.GET_STATUS_MATERIAL]() {
        return new Promise(resolve => {
            cadService.get("Status_Material/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Status_MaterialActions.GETWITHDISABLED_STATUS_MATERIAL]() {
        return new Promise(resolve => {
            cadService.get("Status_Material/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Status_MaterialActions.GET_BY_ID_STATUS_MATERIAL](data) {
        return new Promise(resolve => {
            cadService.get("Status_Material/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Status_MaterialModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Status_MaterialModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Status_MaterialModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Status_MaterialModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Status_MaterialModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Status_MaterialModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Status_MaterialModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Status_MaterialModule.prototype, _h, null);
Status_MaterialModule = __decorate([
    Module
], Status_MaterialModule);
export default Status_MaterialModule;
//# sourceMappingURL=Status_MaterialModule.js.map